import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getContactsPage } from '../api/contacts'
import Layout from '../components/Layout'
import Button from '../components/Button'
import Footer from '../components/Footer'
import { withTranslation, i18n } from '../i18n'
import ContactsAdresses from '../components/ContactsAdresses'
import { PanelsContainer, Panel, Line } from '../styles/contactsStyles'

class Contacts extends React.PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    currentLanguage: PropTypes.string.isRequired
  }

  state = {
    confidentiality: undefined,
    infocentre: '',
    infocentrePhone: '',
    addresses: [],
    mediaInformation: '',
    pressRelease: '',
    organizers: [],
    formLink: undefined,
    headerImage: 'contacts-cover'
  }

  async fetchData() {
    const { currentLanguage } = this.props
    const language = i18n.language || currentLanguage

    const {
      confidentiality,
      infocentre,
      infocentre_phone: infocentrePhone,
      addresses,
      media,
      organizers,
      header_image: headerImage
    } = await getContactsPage(language)

    const mediaInformation = media?.information
    const pressRelease = media?.press_release
    const formLink = media?.form_link

    this.setState({
      confidentiality,
      infocentre,
      infocentrePhone,
      addresses,
      mediaInformation,
      pressRelease,
      formLink,
      organizers,
      headerImage:
        headerImage.url && headerImage.url_2x ? headerImage : 'contacts-cover'
    })
  }

  componentDidMount() {
    this.fetchData()
  }

  static async getInitialProps({ req }) {
    const currentLanguage = req ? req.language : i18n.language
    return {
      namespacesRequired: ['common', 'contacts', 'auth', 'reset-password'],
      currentLanguage
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentLanguage !== prevProps.currentLanguage) {
      this.fetchData()
    }
  }

  render() {
    const { t, currentLanguage } = this.props
    const {
      confidentiality,
      infocentre,
      infocentrePhone,
      addresses,
      mediaInformation,
      pressRelease,
      organizers,
      formLink,
      headerImage
    } = this.state

    return (
      <Layout
        meta={{
          title: t('common:PAGE_CONTACTS_TITLE'),
          description: t('common:PAGE_CONTACTS_SEO_DESC')
        }}
        coverImageUrl={headerImage}
        currentLanguage={currentLanguage}
      >
        <PanelsContainer>
          <div className="column">
            {infocentrePhone && (
              <Panel>
                <div className="panelContent">
                  <h2>{t('infocenter')}</h2>
                  <Line>
                    <a href={`tel:${infocentrePhone}`}>{infocentrePhone}</a>
                  </Line>
                  {infocentre && <Line>{infocentre}</Line>}
                </div>
                <ContactsAdresses addresses={addresses} />
              </Panel>
            )}
          </div>
          <div className="column">
            {mediaInformation && (
              <Panel>
                <div className="panelContent">
                  <h2>{t('info-for-media')}</h2>
                  <Line className="text">{mediaInformation}</Line>
                  {pressRelease && (
                    <a
                      href={pressRelease}
                      target="_blank"
                      className="text press link"
                    >
                      <img
                        className="icon"
                        alt=""
                        src="/static/images/download.svg"
                      />
                      <div>{t('download-press-release')}</div>
                    </a>
                  )}
                  {formLink && (
                    <Button className="button" href={formLink} target="_blank">
                      {t('button-text')}
                    </Button>
                  )}
                </div>
              </Panel>
            )}
            {confidentiality && (
              <Panel>
                <div className="panelContent">
                  <h2>{t('privacy')}</h2>
                  <a
                    href={'/privacy'}
                    target="_blank"
                    className="text link"
                  >
                    <FontAwesomeIcon
                      className="icon"
                      icon="file-alt"
                      size="2x"
                    />
                    <div>{t('privacy-link')}</div>
                  </a>
                </div>
              </Panel>
            )}
          </div>

          <div className="column">
            {organizers &&
              organizers.map((organizer) => (
                <Panel key={organizer.email + organizer.phone}>
                  <div className="panelContent">
                    <h2>{organizer.role}</h2>
                    <Line className="name">{organizer.name}</Line>
                    {organizer.email && (
                      <Line>
                        <a href={`mailto:${organizer.email}`}>
                          {organizer.email}
                        </a>
                      </Line>
                    )}
                    {organizer.phone && (
                      <Line>
                        <a href={`tel:${organizer.phone}`}>{organizer.phone}</a>
                      </Line>
                    )}
                    {organizer.url && (
                      <Line>
                        <a href={`${organizer.url}`}>{organizer.url.split('/')[2]}</a>
                      </Line>
                    )}
                  </div>
                </Panel>
              ))}
          </div>
        </PanelsContainer>
        <Footer />
      </Layout>
    )
  }
}

export default withTranslation(['contacts'])(Contacts)
